type DmsSettings = {
  usingAutomate?: boolean;
  usingAutoSoft?: boolean;
  usingCdk?: boolean;
  usingCdkFortellis?: boolean;
  usingDealerBuilt?: boolean;
  usingDealerTrack?: boolean;
  usingGoodyear?: boolean;
  usingReynolds?: boolean;
};

const SETTINGS_DMS_MAPPINGS = {
  AUTO_SOFT: 'AutoSoft',
  AUTOMATE: 'Automate',
  CDKFORTELLIS: 'Fortellis',
  DEALERBUILT: 'DealerBuilt',
  DEALERTRACK: 'Dealertrack',
  GOODYEAR: 'Goodyear',
  OLD_CDK: 'Old CDK',
  REYNOLDS: 'Reynolds',

  NONE: 'None',
} as const;

type DmsType = (typeof SETTINGS_DMS_MAPPINGS)[keyof typeof SETTINGS_DMS_MAPPINGS];

export const getDmsType = <T extends DmsSettings>(settings: NonNullable<T>): DmsType => {
  if (settings.usingAutomate) return SETTINGS_DMS_MAPPINGS.AUTOMATE;
  if (settings.usingAutoSoft) return SETTINGS_DMS_MAPPINGS.AUTO_SOFT;
  if (settings.usingCdk) return SETTINGS_DMS_MAPPINGS.OLD_CDK;
  if (settings.usingCdkFortellis) return SETTINGS_DMS_MAPPINGS.CDKFORTELLIS;
  if (settings.usingDealerBuilt) return SETTINGS_DMS_MAPPINGS.DEALERBUILT;
  if (settings.usingDealerTrack) return SETTINGS_DMS_MAPPINGS.DEALERTRACK;
  if (settings.usingGoodyear) return SETTINGS_DMS_MAPPINGS.GOODYEAR;
  if (settings.usingReynolds) return SETTINGS_DMS_MAPPINGS.REYNOLDS;

  return SETTINGS_DMS_MAPPINGS.NONE;
};
